<template>
  <div class=maintenanceList>
    <maintenanceList></maintenanceList>
  </div>
</template>

<script>
import maintenanceList from './maintenanceList.vue'

export default {
  components: {
    maintenanceList
  }
}
</script>
<style scoped>
.maintenanceList {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/masterPanel/masterView/maintenance/maintenance.vue